export const log = type => console.log.bind(console, type);



// WEBPACK FOOTER //
// ./src/helpers/log.js